export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export function avatarPath(avatarUrl: string | undefined, avatarFile: string | undefined) {
  try {
    if (!avatarUrl || !avatarFile) return '/media/icons/duotune/general/skull01.svg'
  const url = new URL(avatarUrl || '')
  const final = new URL(url.pathname + '/' + avatarFile || '', avatarUrl)
  return new URL(final).href
  } catch (error) {
    return '';
  }
}

export function imageCoursePath(urlFile: string | undefined, imageFile: string | undefined) {
  try {
    if (!urlFile || !imageFile) return '/media/icons/duotune/general/gen046.svg'
  const url = new URL(urlFile || '')
  const final = new URL(url.pathname + '/' + imageFile || '', urlFile)
  return new URL(final).href
  } catch (error) {
    return '';
  }
}

export function imageMeetingsPath(urlFile: string | undefined, imageFile: string | undefined) {
   try {
    if (!urlFile || !imageFile) return '/media/icons/duotune/general/gen046.svg'
  const url = new URL(urlFile || '')
  const final = new URL(url.pathname + '/' + imageFile || '', urlFile)
  return new URL(final).href
   } catch(error) {
    return '';
   }
}
